import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Eye, MessageSquare } from 'lucide-react';
import { Submission } from '../../utils/dummySubmissions';

interface SubmissionCardProps {
  submission: Submission;
  onView: () => void;
}

const SubmissionCard: React.FC<SubmissionCardProps> = ({ submission, onView }) => {
  return (
    <motion.div
      className="bg-gray-800 rounded-lg overflow-hidden cursor-pointer"
      onClick={onView}
      whileHover={{ y: -5, boxShadow: '0px 10px 20px rgba(0,0,0,0.4)' }}
    >
      <div className="relative">
        <img src={submission.imageUrl} alt="Submission" className="w-full h-auto object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80" />
        <div className="absolute bottom-0 left-0 p-4 text-white">
          <div className="flex items-center">
            <img src={submission.creatorAvatar} alt={submission.creatorName} className="w-8 h-8 rounded-full mr-3 border-2 border-white" />
            <span className="font-semibold">{submission.creatorName}</span>
          </div>
        </div>
      </div>
      <div className="p-4 bg-gray-800 flex justify-between items-center text-sm text-gray-400">
        <div className="flex items-center space-x-4">
          <span className="flex items-center">
            <Heart className="w-4 h-4 mr-1 text-red-500" />
            {submission.likes}
          </span>
          <span className="flex items-center">
            <Eye className="w-4 h-4 mr-1 text-blue-400" />
            {submission.views}
          </span>
          <span className="flex items-center">
            <MessageSquare className="w-4 h-4 mr-1 text-green-400" />
            {submission.comments}
          </span>
        </div>
        <button className="bg-indigo-600 text-white px-3 py-1 rounded-full text-xs font-bold hover:bg-indigo-500">
          Vote
        </button>
      </div>
    </motion.div>
  );
};

export default SubmissionCard;
